/**
 * Outcome of clicking a website-booking email confirmation link (PRD #1358,
 * RS-004). The confirmation page — a small standalone page on our origin,
 * outside the iframe — renders a message per status. Only VERIFIED (and the
 * idempotent ALREADY_VERIFIED) settle the hold into the practice inbox.
 */
export var EmbedBookingVerifyStatus;
(function (EmbedBookingVerifyStatus) {
    /** The link was valid and the hold was settled into the pending-hold inbox. */
    EmbedBookingVerifyStatus["VERIFIED"] = "verified";
    /** The hold was already verified (link clicked twice) — a benign no-op. */
    EmbedBookingVerifyStatus["ALREADY_VERIFIED"] = "already_verified";
    /** The link expired (older than its TTL). The page invites an immediate re-book. */
    EmbedBookingVerifyStatus["EXPIRED"] = "expired";
    /** The token was malformed, forged, or its hold no longer exists / was swept. */
    EmbedBookingVerifyStatus["INVALID"] = "invalid";
})(EmbedBookingVerifyStatus || (EmbedBookingVerifyStatus = {}));
//# sourceMappingURL=embed-booking-verify-status.enum.js.map